import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/careers/gray-leaves-background.png")